import { render, staticRenderFns } from "./Tabbar.vue?vue&type=template&id=16d1e47e&scoped=true&"
import script from "./Tabbar.vue?vue&type=script&lang=js&"
export * from "./Tabbar.vue?vue&type=script&lang=js&"
import style0 from "./Tabbar.vue?vue&type=style&index=0&id=16d1e47e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d1e47e",
  null
  
)

export default component.exports